// ge
import caveira from "./geOps/caveira.png";
import flores from "./geOps/flores.png";
import glaz from "./geOps/glaz.png";
import iana from "./geOps/iana.png";
import lesion from "./geOps/lesion.png";
import maverick from "./geOps/maverick.png";
import mozzie from "./geOps/mozzie.png";
import nokk from "./geOps/nokk.png";
import solis from "./geOps/solis.png";
import valkyrie from "./geOps/valkyrie.png";
import vigil from "./geOps/vigil.png";
import warden from "./geOps/warden.png";
import geLogo from "./geLogo.png";
import geOps from "./geOps.png";

//nh
import ace from "./nhOps/ace.png";
import aruni from "./nhOps/aruni.png";
import ela from "./nhOps/ela.png";
import finka from "./nhOps/finka.png";
import grim from "./nhOps/grim.png";
import iq from "./nhOps/iq.png";
import pulse from "./nhOps/pulse.png";
import smoke from "./nhOps/smoke.png";
import wamai from "./nhOps/wamai.png";
import kali from "./nhOps/kali.png";
import nhLogo from "./nhLogo.webp";
import nhOps from "./nhOps.png";

//rh
import amaru from "./rhOps/amaru.png";
import ash from "./rhOps/ash.png";
import blackbeard from "./rhOps/blackbeard.png";
import buck from "./rhOps/buck.png";
import fuze from "./rhOps/fuze.png";
import goyo from "./rhOps/goyo.png";
import gridlock from "./rhOps/gridlock.png";
import kaid from "./rhOps/kaid.png";
import kapkan from "./rhOps/kapkan.png";
import oryx from "./rhOps/oryx.png";
import sledge from "./rhOps/sledge.png";
import tachanka from "./rhOps/tachanka.png";
import thermite from "./rhOps/thermite.png";
import thorn from "./rhOps/thorn.png";
import rhLogo from "./rhLogo.webp";
import rhOps from "./rhOps.png";

//vs
import alibi from "./vsOps/alibi.png";
import azami from "./vsOps/azami.png";
import blitz from "./vsOps/blitz.png";
import brava from "./vsOps/brava.png";
import capitao from "./vsOps/capitao.png";
import dokkaebi from "./vsOps/dokkaebi.png";
import echo from "./vsOps/echo.png";
import hibana from "./vsOps/hibana.png";
import jackal from "./vsOps/jackal.png";
import jager from "./vsOps/jager.png";
import maestro from "./vsOps/maestro.png";
import mira from "./vsOps/mira.png";
import vsLogo from "./vsLogo.jpg";
import vsOps from "./vsOps.png";

//wg
import bandit from "./wgOps/bandit.png";
import castle from "./wgOps/castle.png";
import clash from "./wgOps/clash.png";
import doc from "./wgOps/doc.png";
import frost from "./wgOps/frost.png";
import lion from "./wgOps/lion.png";
import melusi from "./wgOps/melusi.png";
import montagne from "./wgOps/montagne.png";
import nomad from "./wgOps/nomad.png";
import sens from "./wgOps/sens.png";
import thunderbird from "./wgOps/thunderbird.png";
import twitch from "./wgOps/twitch.png";
import wgLogo from "./wgLogo.jpg";
import wgOps from "./wgOps.png";

let geInfo = {
  name: "Ghost Eyes",
  logo: geLogo,
  coolor: "#008000",
  disc: " Someone has to get their hands dirty to chase the rats out of the darkness. We are Ghosteyes. We find our enemies in their homes and we make them disappear.",
  leader: "CAVERIA",
  sqImg: geOps,
  footerDisc:
    "Ghosteyes was established to be a covert espionage unit made up of operatives that were the best at infiltration, surveillance, intelligence, and elimination.",
  ops: [
    {
      id: 1,
      name: "Caveria",
      src: caveira,
    },
    {
      id: 2,
      name: "flores",
      src: flores,
    },
    {
      id: 3,
      name: "glaz",
      src: glaz,
    },
    {
      id: 4,
      name: "iana",
      src: iana,
    },
    {
      id: 5,
      name: "lesion",
      src: lesion,
    },
    {
      id: 6,
      name: "maverick",
      src: maverick,
    },
    {
      id: 7,
      name: "mozzie",
      src: mozzie,
    },
    {
      id: 8,
      name: "nokk",
      src: nokk,
    },
    {
      id: 9,
      name: "solis",
      src: solis,
    },
    {
      id: 10,
      name: "valkyrie",
      src: valkyrie,
    },
    {
      id: 11,
      name: "vigil",
      src: vigil,
    },
    {
      id: 12,
      name: "warden",
      src: warden,
    },
  ],
};
let nhInfo = {
  name: "Night Haven",
  logo: nhLogo,
  coolor: "#7b7b7b",
  disc: "In my life, I’ve often found that the great rarely fit traditional standards. When you confine excellence, it suffocates. In removing these restraints, I have redefined what an operational unit can be. Some might see us as selfish and opportunistic. Let them. Nighthaven will leave them in the dust as they soar.",
  leader: "KALI",
  sqImg: nhOps,
  footerDisc:
    "Kali founded the Private Military Company Night Haven to operate overseas. The organization regularly negotiates multi-million dollar contracts with clients across the globe.",
  ops: [
    {
      id: 1,
      name: "kali",
      src: kali,
    },
    {
      id: 2,
      name: "ace",
      src: ace,
    },
    {
      id: 3,
      name: "aruni",
      src: aruni,
    },
    {
      id: 4,
      name: "ela",
      src: ela,
    },
    {
      id: 5,
      name: "finka",
      src: finka,
    },
    {
      id: 6,
      name: "grim",
      src: grim,
    },
    {
      id: 7,
      name: "pulse",
      src: pulse,
    },
    {
      id: 8,
      name: "iq",
      src: iq,
    },
    {
      id: 9,
      name: "smoke",
      src: smoke,
    },
    {
      id: 10,
      name: "wamai",
      src: wamai,
    },
  ],
};

let rhInfo = {
  name: "Red Hammer",
  logo: rhLogo,
  coolor: "#b71c1c",
  disc: "There's only one kind of unit you can send in when you need to unleash some chaos. That's us. They say when you read a report from Redhammer, you shouldn't look at the details too close. If you had the stomach for the kind of work we do, you'd be on the field with us.",
  leader: "THERMITE",
  sqImg: rhOps,
  footerDisc:
    "Redhammer was established to undertake high-risk missions, acting as the cavalry if necessary.",
  ops: [
    {
      id: 1,
      name: "thermite",
      src: thermite,
    },
    {
      id: 2,
      name: "amaru",
      src: amaru,
    },
    {
      id: 3,
      name: "ash",
      src: ash,
    },
    {
      id: 4,
      name: "blackbeard",
      src: blackbeard,
    },
    {
      id: 5,
      name: "buck",
      src: buck,
    },
    {
      id: 6,
      name: "fuze",
      src: fuze,
    },
    {
      id: 7,
      name: "goyo",
      src: goyo,
    },
    {
      id: 8,
      name: "gridlock",
      src: gridlock,
    },
    {
      id: 9,
      name: "kaid",
      src: kaid,
    },
    {
      id: 10,
      name: "kapkan",
      src: kapkan,
    },
    {
      id: 11,
      name: "oryx",
      src: oryx,
    },
    {
      id: 12,
      name: "sledge",
      src: sledge,
    },
    {
      id: 13,
      name: "tachanka",
      src: tachanka,
    },
    {
      id: 14,
      name: "thorn",
      src: thorn,
    },
  ],
};

let vsInfo = {
  name: "Viper Strike",
  logo: vsLogo,
  coolor: "#e2bc1e",
  disc: "Viperstrike has the expertise and the connections to ensure we can continue to performe our duty, and Rainbow's standard of quality is never questioned.",
  leader: "HIBANA",
  sqImg: vsOps,
  footerDisc:
    "Viperstrike was established to be a diversified and versatile support unit made of operators that act with surgical precision, discipline and excellence.",
  ops: [
    {
      id: 1,
      name: "hibana",
      src: hibana,
    },
    {
      id: 2,
      name: "alibi",
      src: alibi,
    },
    {
      id: 3,
      name: "azami",
      src: azami,
    },
    {
      id: 4,
      name: "blitz",
      src: blitz,
    },
    {
      id: 5,
      name: "brava",
      src: brava,
    },
    {
      id: 6,
      name: "capitao",
      src: capitao,
    },
    {
      id: 7,
      name: "dokkaebi",
      src: dokkaebi,
    },
    {
      id: 8,
      name: "echo",
      src: echo,
    },
    {
      id: 9,
      name: "jackal",
      src: jackal,
    },
    {
      id: 10,
      name: "jager",
      src: jager,
    },
    {
      id: 11,
      name: "maestro",
      src: maestro,
    },
    {
      id: 12,
      name: "mira",
      src: mira,
    },
  ],
};

let wgInfo = {
  name: "Wolf Guard",
  logo: wgLogo,
  coolor: "#00436b",
  disc: "When we go out there, we work twice as hard to protect others. Whatever we have to do, we put the people first. That will be our focus. With unwavering diligence, we defend, and we get to say that when Wolfguard is on the field, things will be different.",
  leader: "DOC",
  sqImg: wgOps,
  footerDisc:
    "Wolfguard was established to become the world's foremost humanitarian military unit, undertaking missions where collateral damage is not an option.",
  ops: [
    {
      id: 1,
      name: "doc",
      src: doc,
    },
    {
      id: 2,
      name: "bandit",
      src: bandit,
    },
    {
      id: 3,
      name: "castle",
      src: castle,
    },
    {
      id: 4,
      name: "clash",
      src: clash,
    },
    {
      id: 5,
      name: "frost",
      src: frost,
    },
    {
      id: 6,
      name: "lion",
      src: lion,
    },
    {
      id: 7,
      name: "melusi",
      src: melusi,
    },
    {
      id: 8,
      name: "montagne",
      src: montagne,
    },
    {
      id: 9,
      name: "nomad",
      src: nomad,
    },
    {
      id: 10,
      name: "sens",
      src: sens,
    },
    {
      id: 11,
      name: "thunderbird",
      src: thunderbird,
    },
    {
      id: 12,
      name: "twitch",
      src: twitch,
    },
  ],
};

export default { geInfo, nhInfo, rhInfo, vsInfo, wgInfo };
